module.exports = __webpack_public_path__ + "static/media/service2.9fd5736d.svg";